import { render, staticRenderFns } from "./MultideviceForm.vue?vue&type=template&id=3b1381fe&"
import script from "./MultideviceForm.vue?vue&type=script&lang=js&"
export * from "./MultideviceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports